import Vue from 'vue'

export default {
  get(locationId) {
    return Vue.http.get(`app-services/v2/locations/${locationId}`)
  },
  getLocations(payload) {
    return Vue.http.post(`app-services/v2/locations/list`, payload)
  },
  addProducts(payload) {
    return Vue.http.post('location/add-products', payload)
  },
  getForUser({ companyId }) {
    return Vue.http.get(`app-services/v2/users/company/${companyId}/locations`)
  },
  update(payload) {
    return Vue.http.post('location/update', payload)
  },
  updateAddress(payload) {
    const { locationId, ...addressData } = payload
    return Vue.http.put(`app-services/v2/locations/${locationId}/address`, addressData)
  }
}
